// Hiérarchie des administrateurs (miroir de backend/config/permissions.js).
// L'accès réel est toujours vérifié côté serveur.
export const OWNER_ID = '317411730709807106';

export const ROLE_LABELS = {
    owner: 'Propriétaire',
    siteAdmin: 'Administrateur Site',
    serverAdmin: 'Administrateur Serveur',
    member: 'Membre'
};

// Droits attribuables à un Administrateur Serveur, dans l'ordre d'affichage
export const SERVER_PERMISSIONS = [
    { key: 'configuration', label: 'Configuration', icon: 'sliders' },
    { key: 'bareme', label: 'Barèmes', icon: 'scale' },
    { key: 'tempo', label: 'Tempo', icon: 'clock' },
    { key: 'saisons', label: 'Saisons', icon: 'trophy' },
    { key: 'fusion', label: 'Fusion', icon: 'copy' },
    { key: 'zones', label: 'Zones', icon: 'map' },
    { key: 'reservation', label: 'Réservations', icon: 'clipboard' },
    { key: 'statistiques', label: 'Statistiques', icon: 'chart' },
    { key: 'pepites', label: 'Pépites', icon: 'gem' },
    { key: 'encheres', label: 'Enchères', icon: 'hammer' },
    { key: 'rattrapage', label: 'Rattrapage', icon: 'history' },
    { key: 'pl', label: 'Service PL', icon: 'backpack' },
    { key: 'personnages', label: 'Personnages', icon: 'users' },
    // Page Événements masquée pour le moment : droit non proposé
    { key: 'evenements', label: 'Événements', icon: 'calendar', hidden: true }
];
